// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__152QU","row":"Node_row__2Tnsy","label":"Node_label__5GKj5","footer":"Node_footer__Iye_X"};